export default function Footer() {
  const linkGroups = [
    {
      title: "Categorias",
      links: [
        { label: "Tênis", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
        { label: "Moletons", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
        { label: "Camisetas", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
        { label: "Jaquetas", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
        { label: "Bolsas", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
      ],
    },
    {
      title: "Links Úteis",
      links: [
        { label: "Hoobuy Sheet", url: "https://kaspreadsheet.com" },
        { label: "Guia Completo", url: "/artigo/guia-hoobuy-spreadsheet" },
        { label: "Segurança", url: "#seguranca" },
        { label: "Comparações", url: "#comparacao" },
        { label: "FAQ", url: "#faq" },
      ],
    },
    {
      title: "Contato",
      links: [
        { label: "Sobre Nós", url: "#" },
        { label: "Privacidade", url: "#" },
        { label: "Disclaimer", url: "#" },
        { label: "Termos de Uso", url: "#" },
      ],
    },
  ];

  return (
    <footer className="py-12 md:py-16 bg-foreground-950 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left - Brand */}
          <div className="lg:w-2/5">
            <h3 className="font-heading text-xl md:text-2xl font-bold mb-2">
              Hoobuy<span className="text-primary-400">Spreadsheet</span>
            </h3>
            <p className="text-white/50 text-sm mb-6 leading-relaxed">
              A maior Hoobuy Spreadsheet em português. Links atualizados diariamente com os melhores produtos de moda, sneakers e streetwear.
            </p>
            <div className="flex items-center gap-3 mb-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 transition-colors cursor-pointer"
              >
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <span className="text-white/40 text-xs">hoobuy.monster</span>
            </div>
          </div>

          {/* Right - Links */}
          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {linkGroups.map((group) => (
              <div key={group.title}>
                <h4 className="text-white/40 text-xs font-semibold uppercase tracking-wider mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => {
                    const isExternal = link.url.startsWith("http");
                    return (
                      <li key={link.label}>
                        <a
                          href={link.url}
                          target={isExternal ? "_blank" : undefined}
                          rel={isExternal ? "noopener nofollow" : undefined}
                          className="text-white/55 text-sm hover:text-white transition-colors cursor-pointer"
                        >
                          {link.label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Hoobuy Spreadsheet. Todos os direitos reservados.
          </p>
          <p className="text-white/20 text-xs">
            Atualizado em: {new Date().toLocaleDateString("pt-BR")}
          </p>
        </div>
      </div>
    </footer>
  );
}